import React, { Component } from 'react';
import DatePicker from 'material-ui/DatePicker';
import RaisedButton from 'material-ui/RaisedButton';
import Box from '../ui/Box';
import ReactEcharts from 'components/ReactECharts';
import CHARTCONFIG from 'constants/ChartConfig';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';

//services
import DataService from '../../services/DataService'; var ds = DataService;
import Helper from '../../services/Helper'; var help = Helper;

const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  slide: {
    padding: 10,
  },
};

const MONTH_NAMES = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
};


var CHART_TEMPLATE = {
  loading: true,
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ["Number of Checkins"],
    textStyle: {
      color: CHARTCONFIG.color.text
    }
  },
  toolbox: {
    show: true,
    feature: {
      saveAsImage: {
        show: true,
        title: 'save',
        name: ''
      },
      dataView: {
        show: true,
        readOnly: true,
        title: 'View',
        lang: [
          "Number Of Checkin(s)",
          "Close",
        ],
        buttonColor: "rgb(0, 188, 212)"
      }
    }
  },
  calculable: true,
  dataZoom: {
    show: false,
    realtime: true,
    y: 36,
    height: 20,
  },
  xAxis: [
    {
      type: 'category',
      boundaryGap: false,
      data: [],
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      splitLine: {
        lineStyle: {
          color: CHARTCONFIG.color.splitLine
        }
      }
    }
  ],
  yAxis: [
    {
      type: 'value',
      axisLabel: {
        formatter: '{value}',
        textStyle: {
          color: CHARTCONFIG.color.text
        }
      },
      splitLine: {
        lineStyle: {
          color: CHARTCONFIG.color.splitLine
        }
      },
      splitArea: {
        show: true,
        areaStyle: {
          color: CHARTCONFIG.color.splitArea
        }
      }
    }
  ],
  series: [
    {
      name: 'Number of Checkins',
      type: 'line',
      data: [],
      markPoint: {
        data: [
          { type: 'max', name: 'Max' },
          { type: 'min', name: 'Min' }
        ]
      },
      markLine: {
        data: [
          { type: 'average', name: 'Average' }
        ]
      }
    }
  ]
}

export default class RoomStatsMain extends Component {

  constructor(props) {
    super(props);
    let c = new Date();
    let d = new Date(c);
    d.setHours(0, 0, 0, 0);
    d.setDate(1);
    this.state = {
      start: d,
      maxStart: d,
      end: c,
      total_checkins: 0,
      raw_data: [],
      show_data: false,
      chartData: CHART_TEMPLATE,
      longest_stay: 0,
      average_stay: 0,
      busiest_room: '-'

    };
  }

  getCheckinReport(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    this.setState({
      total_checkins: 0,
      raw_data: [],
      show_data: false,
      chartData: CHART_TEMPLATE,
      longest_stay: 0,
      average_stay: 0,
      busiest_room: '-'

    }, () => {
      ds.postGetCheckinReport({
        from_date: this.state.start.getTime(),
        to_date: this.state.end.getTime(),

      }, data => {

        let total_checkins = data.count;
        let longest_stay = this.state.longest_stay;
        let average_stay = this.state.average_stay;
        let busiest_room = this.state.busiest_room;

        if (data.nights && data.nights.length > 0) {
          let raw_data = data.nights;
          this.state.new_raw_data = raw_data;
        }


        if (data.docs) {
          let raw_data = data.docs;
          let xAxisObj = {};
          let rooms = {};

          for (let doc of data.docs) {
            let i = doc.checkin_in_record;
            if (i.check_in_time && new Date(i.check_in_time) != 'Invalid Date') {
              let date_str = MONTH_NAMES[new Date(i.check_in_time).getMonth()] + ' ' + new Date(i.check_in_time).getDate().toString();
              if (!xAxisObj[date_str]) {
                xAxisObj[date_str] = 0;
              }
              xAxisObj[date_str]++;
            }

            let stay = help.findDaysInterval(new Date(i.check_in_time).getTime(), new Date(i.check_out_time).getTime());
            if (stay > longest_stay) {
              longest_stay = stay;
            }

            average_stay += stay;

            if (!rooms[doc.room_details[0].name]) {
              rooms[doc.room_details[0].name] = 0;
            }
            rooms[doc.room_details[0].name]++;

          }

          average_stay = Math.round(average_stay / (data.count) * 100) / 100;
          let xAxisData = Object.keys(xAxisObj);
          let yAxisData = [];

          for (let i of xAxisData) {
            yAxisData.push(xAxisObj[i]);
          }

          let chart_template = this.state.chartData;
          chart_template.xAxis[0].data = xAxisData;
          chart_template.series[0].data = yAxisData;

          busiest_room = Object.keys(rooms).reduce((a, b) => rooms[a] > rooms[b] ? a : b);

          const name = new Date(this.state.start).toDateString() + ' - ' + new Date(this.state.end).toDateString() + ' check-ins'
          this.state.chartData.toolbox.feature.saveAsImage.name = name;

          this.setState({
            chartData: chart_template,
            show_data: true,
            raw_data: raw_data,
            total_checkins: total_checkins,
            longest_stay: longest_stay,
            average_stay: average_stay,
            busiest_room: busiest_room
          });
        }

      }, err => { });
    });
  }

  render() {
    return (
      <Box header='Check-in Stats'>
        <div>
          <form className="smart-form " onSubmit={this.getCheckinReport.bind(this)}>
            <fieldset style={{ paddingLeft: '2.4rem' }}>
              <section>
                <div className="false-placeholder">Start Date</div>
                <DatePicker
                  hintText="From"
                  container="inline"
                  name="ch_in_time"
                  className="col-sm-5 w-100 zeroPadding"
                  value={this.state.start}
                  autoOk
                  style={{
                    maxWidth: '35%'
                  }}
                  onChange={(e, value) => {
                    this.setState({
                      start: value
                    })
                  }}
                />
              </section>

              <section>
                <div className="false-placeholder" style={{ marginTop: '-1.2rem' }}>End Date</div>
                <DatePicker
                  hintText="To"
                  container="inline"
                  name="end"
                  className="col-sm-5 w-100 zeroPadding"
                  value={this.state.end}
                  autoOk
                  style={{
                    maxWidth: '35%'
                  }}
                  onChange={(e, value) => {
                    this.setState({
                      end: value
                    })
                  }}
                />
              </section>

              <section>
                <div className="col-sm-2">
                  <RaisedButton
                    label="Go"
                    primary
                    type="submit"
                    style={{ float: 'right' }}
                  />
                </div>
              </section>
            </fieldset>
          </form>
        </div>

        {
          this.state.show_data ?
            <div>
              <div className="col-sm-12 mt-4vw">
                <div className="col-xl-3 col-sm-6">
                  <div className="box box-default customBox">
                    <div className="box-top">
                      <span>{this.state.total_checkins}</span>
                    </div>

                    <div className="box-info">
                      <span>TOTAL CHECK-INS</span>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="box box-default customBox">
                    <div className="box-top">
                      <span>{this.state.average_stay}<span className="size-h5"> Days</span></span>
                    </div>

                    <div className="box-info">
                      <span>AVERAGE STAY</span>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="box box-default customBox">
                    <div className="box-top">
                      <span>{this.state.longest_stay}<span className="size-h5"> Days</span></span>
                    </div>

                    <div className="box-info">
                      <span>LONGEST STAY</span>
                    </div>
                  </div>
                </div>

                <div className="col-xl-3 col-sm-6">
                  <div className="box box-default customBox">
                    <div className="box-top">
                      <span>{this.state.busiest_room}</span>
                    </div>

                    <div className="box-info">
                      <span>BUSIEST ROOM</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4vw col-sm-12">
                <div className="box box-default col-md-6 customBox">
                  <div className="box-heading">Number of Checkins in given period</div>
                  <div className="box-body">
                    <ReactEcharts option={this.state.chartData} showLoading={false} />
                  </div>
                </div>

                <div className="box box-default customBox col-md-6">
                  <Table
                    height={'37vh'}
                    fixedHeader={true}
                    fixedFooter={true}
                    selectable={false}
                    multiSelectable={false}
                  >
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                      <TableRow>
                        <TableHeaderColumn colSpan="4"
                          style={{ color: 'black', fontWeight: '500', padding: '0.75rem 1.25rem' }}
                          className="align-center font-14px"
                        >
                          Day Wise Checkin Record in given period
                        </TableHeaderColumn>
                      </TableRow>

                      <TableRow>
                        <TableHeaderColumn tooltip="Date">Date</TableHeaderColumn>
                        <TableHeaderColumn tooltip="Room">Room</TableHeaderColumn>
                        <TableHeaderColumn tooltip="Guest Name">Guest Name</TableHeaderColumn>
                        <TableHeaderColumn tooltip="Checkout Date">Checkout</TableHeaderColumn>

                      </TableRow>
                    </TableHeader>
                    <TableBody
                      displayRowCheckbox={false}
                      showRowHover={true}
                      stripedRows={false}
                    >
                      {
                        this.state.raw_data.map((row, index) => (
                          <TableRow key={index}>
                            <TableRowColumn style={{ overflow: 'visible' }}>{row.checkin_in_record ? help.TimeStampToDate(row.checkin_in_record.check_in_time) : ''}</TableRowColumn>
                            <TableRowColumn style={{ overflow: 'visible' }}>{row.room_details && row.room_details[0] ? row.room_details[0].name : ''}</TableRowColumn>
                            <TableRowColumn style={{ overflow: 'visible' }}>{row.checkin_in_record ? row.checkin_in_record.guest_name : ''}</TableRowColumn>
                            <TableRowColumn style={{ overflow: 'visible' }}>{row.checkin_in_record ? help.TimeStampToDate(row.checkin_in_record.check_out_time) : ''}</TableRowColumn>
                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </div>

                <div className="box box-default customBox col-md-6">
                  <Table
                    height={'37vh'}
                    fixedHeader={true}
                    fixedFooter={true}
                    selectable={false}
                    multiSelectable={false}
                  >
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                      <TableRow>
                        <TableHeaderColumn colSpan="2"
                          style={{ color: 'black', fontWeight: '500', padding: '0.75rem 1.25rem' }}
                          className="align-center font-14px"
                        >
                          Number of Nights in given period
                        </TableHeaderColumn>
                      </TableRow>

                      <TableRow>
                        <TableHeaderColumn  className="align-center" tooltip="Room">Room</TableHeaderColumn>
                        <TableHeaderColumn  className="align-center" tooltip="No of Nights">No of Nights</TableHeaderColumn>

                      </TableRow>
                    </TableHeader>
                    <TableBody
                      displayRowCheckbox={false}
                      showRowHover={true}
                      stripedRows={false}
                    >
                      {
                        this.state.new_raw_data.map((row, index) => (
                          <TableRow key={index} >
                            <TableRowColumn style={{ overflow: 'visible' }} className="align-center">{row.room_no}</TableRowColumn>
                            <TableRowColumn style={{ overflow: 'visible' }} className="align-center">{row.nights}</TableRowColumn>
                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </div>

              </div>
            </div>
            : null
        }
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/stats/RoomStatsMain.js